import React, {useState} from 'react';
import { Typography } from '@mui/material';

const CartQuantity = ({item}) => {
    const [quantities, setQuantities] = useState(1);

    const handleQuantityIncrement = (itemId) => {
        console.log('increase')
        setQuantities(quantities + 1)
      };
      const handleQuantityDecrement = (itemId)=>{
    
        console.log('decrease')
        if(quantities>1){
            setQuantities(quantities - 1)
        }
      }
  return (
    <Typography variant='outlined' sx={{display:'flex', justifyContent:'space-between', gap:1, border:'1px solid rgba(228, 233, 238, 1)', py:'.5rem', px:2, borderRadius:'8px', width:'fit-content'}}>
    <span onClick={()=>handleQuantityDecrement(item.id)} style={{cursor:'pointer', color:'rgba(86, 4, 246, 1)'}}>-</span>
    <span>{quantities}</span>
    <span onClick={()=>handleQuantityIncrement(item.id)} style={{cursor:'pointer', color:'rgba(86, 4, 246, 1)'}}>+</span>
    </Typography>
  )
}

export default CartQuantity